'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FullScreenErrorModal = require('../../modal/FullScreenErrorModal');

var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);

var _ModalActionsList = require('../../modal/ModalActionsList');

var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var BrowserUnsupportedFullScreenWarning = function BrowserUnsupportedFullScreenWarning(props) {
    var actions = [{ text: 'Install Google Chrome instead...', href: 'https://www.google.com.au/chrome/' }, { text: 'Continue anyway', func: props.acknowledgeUnsupportedBrowser }];

    return _react2.default.createElement(
        _FullScreenErrorModal2.default,
        null,
        _react2.default.createElement(
            'h2',
            null,
            'Sorry, your browser isn\'t supported yet'
        ),
        _react2.default.createElement(
            'p',
            { className: 'explanation' },
            'We\'re working hard to make Milanote work in Microsoft Edge, but we\'re not there yet.'
        ),
        _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
    );
};

BrowserUnsupportedFullScreenWarning.propTypes = {
    permissionsError: _propTypes2.default.object,
    currentBoard: _propTypes2.default.object,
    acknowledgeUnsupportedBrowser: _propTypes2.default.func.isRequired
};

exports.default = BrowserUnsupportedFullScreenWarning;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/browserSupport/BrowserUnsupportedFullScreenWarning.js
// module id = 1761
// module chunks = 0